import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "../../components/layout/index.ts";
import { getTelegram } from "../../lib/telegram.ts";

export function NotFoundPage() {
  const navigate = useNavigate();
  const tg = getTelegram();

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => navigate(-1);
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <div className="card p-6 text-center">
        <h1 className="page-title mb-2">Страница не найдена</h1>
        <p className="text-sm text-gray-500 mb-4">
          Запрошенная страница не существует или была перемещена.
        </p>
        <button onClick={() => navigate("/")} className="btn-primary">
          На главную
        </button>
      </div>
    </Layout>
  );
}
